/**
 * O titular-empresa no cabeçalho dos PDFs do cliente.
 *
 * Quando a conta é de pessoa jurídica, o documento impresso leva a razão social e o CNPJ sob a
 * data de geração. Pessoa física não ganha linha nenhuma: o CPF de uma pessoa não entra em
 * documento que ela costuma repassar (inquilino, contador, condomínio).
 *
 * Os PDFs são funções síncronas com muitos pontos de chamada; em vez de mudar a assinatura de
 * todas, o titular é lido uma vez (`TitularPdfSync`, montado no layout) e guardado aqui. Se a
 * leitura ainda não voltou, o PDF sai SEM a linha — nunca com uma errada.
 */
import { formatCNPJ, validateCNPJ } from "@/lib/cnpj";

let linhaAtual: string | null = null;

export interface TitularParaPdf {
  tipo_pessoa?: string | null;
  razao_social?: string | null;
  /** Documento já em claro. */
  documento?: string | null;
}

/** "Razão Social · CNPJ 00.000.000/0000-00"; `null` para pessoa física ou sem razão social. */
export function linhaDoTitular(t: TitularParaPdf | null | undefined): string | null {
  if (!t || t.tipo_pessoa !== "juridica") return null;
  const razao = (t.razao_social ?? "").trim();
  if (!razao) return null;
  const doc = t.documento ?? "";
  return doc && validateCNPJ(doc) ? `${razao} · CNPJ ${formatCNPJ(doc)}` : razao;
}

export function definirTitularDoPdf(linha: string | null): void {
  linhaAtual = linha;
}

export function titularDoPdfAtual(): string | null {
  return linhaAtual;
}

interface DocLike {
  setFontSize: (n: number) => unknown;
  setTextColor: (c: string) => unknown;
  text: (t: string, x: number, y: number, o?: { align?: "center" | "right" | "left" | "justify" }) => unknown;
}

/** Desenha a linha do titular sob "Gerado em", à direita, dentro da faixa do cabeçalho. */
export function desenharTitular(doc: DocLike, pageW: number, margin: number): void {
  if (!linhaAtual) return;
  doc.setFontSize(8);
  doc.setTextColor("#AAB8C8");
  doc.text(linhaAtual, pageW - margin, 28, { align: "right" });
}
